"use strict";

angular.module("models").service("ActionHistoriesService", ["ApiService", function (ApiService) {
  var that = this;

  var params = {
    name: "actionHistories",
    attributesForCache: ["name"],
    formatName: function formatName(element) {
      return element.name ? element.name : "???";
    },
    defaultOrder: { date: -1 }
  };

  angular.extend(that, ApiService.getModelBis(params));
}]);